import { render, staticRenderFns } from "./SupplierBasic.vue?vue&type=template&id=1bc5b194&scoped=true&"
import script from "./SupplierBasic.vue?vue&type=script&lang=js&"
export * from "./SupplierBasic.vue?vue&type=script&lang=js&"
import style0 from "./SupplierBasic.vue?vue&type=style&index=0&id=1bc5b194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc5b194",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VContainer,VRow})
